<template>
  <div style="text-align: center; margin: 0 auto; max-width: 640px">
    <h2>在线注册-主办方</h2>
    <el-form
      :model="hostForm"
      status-icon
      :rules="hostFormRules"
      ref="hostForm"
      label-width="100px"
    >
      <el-form-item label="手机号" prop="mobile">
        <el-row>
          <el-col :span="24"
            ><el-input
              placeholder="请输入手机号码"
              v-model="hostForm.mobile"
              maxlength="255"
            >
              <el-button slot="append" :disabled="isSending" @click="sendSms">{{
                smsText
              }}</el-button></el-input
            >
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="验证码" prop="smsCode">
        <el-row>
          <el-col :span="24"
            ><el-input
              placeholder="请输入验证码"
              v-model="hostForm.smsCode"
              maxlength="255"
            ></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="登录密码" prop="password">
        <el-row>
          <el-col :span="16">
            <el-input
              type="password"
              v-model="hostForm.password"
              maxlength="255"
            ></el-input></el-col
          ><el-col :span="8"><span>登录密码最少5位数字母数字</span> </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-row>
          <el-col :span="16"
            ><el-input
              type="password"
              v-model="hostForm.confirmPassword"
              maxlength="255"
            ></el-input></el-col
          ><el-col :span="8"><span>确认密码最少5位数字母数字</span></el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="单位名称" prop="name">
        <el-row>
          <el-col :span="16">
            <el-input
              v-model="hostForm.name"
              maxlength="255"
            ></el-input></el-col
        ></el-row>
      </el-form-item>
      <el-form-item label="负责人" prop="businessOwner">
        <el-row>
          <el-col :span="16">
            <el-input
              v-model="hostForm.businessOwner"
              maxlength="255"
            ></el-input></el-col
        ></el-row>
      </el-form-item>

      <el-form-item label="联系方式" prop="contact">
        <el-row>
          <el-col :span="16">
            <el-input
              v-model="hostForm.contact"
              maxlength="255"
            ></el-input></el-col
        ></el-row>
      </el-form-item>
      <el-form-item label="QQ" prop="qQ">
        <el-row>
          <el-col :span="16">
            <el-input v-model="hostForm.qQ" maxlength="255"></el-input></el-col
        ></el-row>
      </el-form-item>
      <el-form-item label="Email" prop="email">
        <el-row>
          <el-col :span="16">
            <el-input
              v-model="hostForm.email"
              maxlength="255"
            ></el-input></el-col
        ></el-row>
      </el-form-item>
      <el-form-item label="单位简介" prop="description">
        <el-row>
          <el-col :span="16">
            <el-input
              type="textarea"
              :rows="6"
              placeholder="请输入单位简介"
              v-model="hostForm.description"
            >
            </el-input></el-col
        ></el-row>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-link href="#/login" type="success" style="margin-right: 20px"
        >已有账号立即登录</el-link
      >
      <el-button type="primary" @click="RegisterHost" :loading="isLoading"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
import HostApi from "../apis/host";
import SMSAPI from "../apis/sms";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.hostForm.password !== "") {
          this.$refs.hostForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.hostForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      const reg = /^[0-9]{11}$/;
      if (value == "" || value == undefined || value == null) {
        callback();
      } else {
        if (!reg.test(value) && value != "") {
          callback(new Error("请输入正确的手机号码"));
        } else {
          callback();
        }
      }
    };
    let validateCode = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入验证码"));
      } else if (value.length != 5) {
        return callback(new Error("输入正确5位验证码"));
      } else {
        return callback();
      }
    };
    return {
      isLoading: false,
      isSending: false,
      timeCounter: 60,
      smsText: "获取验证码",
      hostForm: {
        mobile: null,
        smsCode: null,
        password: null,
        confirmPassword: null,
        name: null,
        businessOwner: null,
        contact: null,
        qQ: null,
        email: null,
        description: null,
      },
      hostFormRules: {
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        smsCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            validator: validateCode,
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
      },
    };
  },
  methods: {
    RegisterHost() {
      this.isLoading = true;
      this.$refs.hostForm.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.hostForm);
          HostApi.register(params)
            .then((result) => {
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "注册成功",
                  duration: 2000,
                });
                this.$refs["hostForm"].resetFields();                
                this.isLoading = false;
                 this.$alert('主办方账户注册成功', '提示', {confirmButtonText: '确定',
               callback: action => {
                  this.$router.push({ path: "/login" });
                 }
                 });
              } else {
                this.$message.error({
                  showClose: true,
                  message: result.message,
                  duration: 2000,
                });
                this.isLoading = false;
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "请求异常",
                duration: 2000,
              });
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });
    },
    sendSms() {
      if (this.isSending) {
        this.$message.warning({
          showClose: true,
          message: "验证码已经发送，请稍后",
          duration: 2000,
        });
        return;
      }
      if (
        this.hostForm.mobile == null ||
        this.hostForm.mobile == "" ||
        !/^[0-9]{11}$/.test(this.hostForm.mobile)
      ) {
        this.$message.error({
          showClose: true,
          message: "手机号码不正确",
          duration: 2000,
        });return;
      }
      this.isSending = true;
      let that=this;
      SMSAPI.sendSms({ phoneNumber: this.hostForm.mobile, type: 1 })
        .then((result) => {
          if (result.code == 0) {
            this.$message.success({
              showClose: true,
              message: "验证码已经发送，请注意查收",
              duration: 2000,
            });
            that.timeCounter = 60;
            var intervalTimer = setInterval(() => {
              that.timeCounter--;
              that.smsText = that.timeCounter + "后重新获取";
              if (that.timeCounter <= 0) {
                that.isSending = false;
                that.smsText = "重新获取验证码";
                clearInterval(intervalTimer);
              }
            },1000);
          } else {
            this.$message.error({
              showClose: true,
              message: result.message,
              duration: 2000,
            });
            this.isSending = false;
          }
        })
        .catch((error) => {
          this.$message.error({
            showClose: true,
            message: "请求异常",
            duration: 2000,
          });
          this.isSending = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/register.vue